import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { usePartnerPermissions } from '@atlassian/mpac-ui';
import React from 'react';
import { getFilters } from './filtersToBeShownByReport';
export default function useReportsFilters(filter) {
  var _permissions$canViewS;
  const {
    reportingAppsFilterOptions,
    reportName,
    queryParams,
    excludedFilters
  } = filter;
  const permissions = usePartnerPermissions();
  const [filters, setFilters] = React.useState([]);
  const {
    showBenchmarkingUiDropdown
  } = useFeatureFlags();
  const canViewSalesReport = (_permissions$canViewS = permissions === null || permissions === void 0 ? void 0 : permissions.canViewSalesReport) !== null && _permissions$canViewS !== void 0 ? _permissions$canViewS : false;
  React.useEffect(() => {
    const updatedFilters = getFilters(reportingAppsFilterOptions, reportName, queryParams, !!showBenchmarkingUiDropdown, excludedFilters);
    setFilters(updatedFilters);
  }, [reportingAppsFilterOptions, reportName, queryParams, canViewSalesReport, showBenchmarkingUiDropdown]);
  return filters;
}